module.exports = __webpack_public_path__ + "static/media/navBar-activities.c1f4b9b4.svg";